<!--
  @Author: hanjainxin
  @Desc: 维护提示
  @Date: 2019-07-26
-->
<template>
  <div class="page-main" id="homePage">
    <img class="img-title" src="../../../static/staticPages/pic_system_upgrade.png" />
    <p class="home-text">系统升级</p>
    <p class="home-text-tis">我们的程序员正在努力升级中</p>
  </div>
</template>
<script>
export default {
  name: "index",
  components: {},

  data() {
    return {};
  },

  computed: {},

  created() {},

  mounted() {},

  methods: {}
};
</script>
<style>
</style>
<style lang="scss" scoped>
@import "../../styles/variable";
#homePage {
  padding-top: 160px;
  @include align-center;
  .img-title {
    width: 400px;
    margin-bottom: 24px;
  }
  .home-text {
    font-size: 24px;
    color: #272727;
    letter-spacing: 0;
    text-align: center;
    line-height: 32px;
  }
  .home-text-tis {
    font-size: 14px;
    color: #595959;
    letter-spacing: 0;
    text-align: center;
    line-height: 32px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/staticPages/homeUpdata.vue